// GENERATED by .scratch/gen-hand-mirror.ts - do not hand-edit.
// TheCore's Right->Left positional reflection, recovered once by aligning the vendored v6
// US-Qwerty hand pair command-by-command and symmetrized to a complete involution. Committed as
// version-stable data, like the locale `tokens` tables; hand-mirror.test.ts re-derives it from the
// fixture pair and fails if this drifts, so regenerate and recommit if v6's seeds ever change.
// A slot is a KeyboardEvent.code (char keys) or a raw .SC2Hotkeys named token (Enter, Tab, F-keys).
export const HAND_MIRROR: Record<string, string> = {
  BackMouseButton: "BackMouseButton",
  Backquote: "Backquote",
  Backslash: "CapsLock",
  Backspace: "Backquote",
  BracketLeft: "KeyQ",
  BracketRight: "Tab",
  CapsLock: "Backslash",
  Comma: "KeyC",
  Digit0: "Digit3",
  Digit1: "Equal",
  Digit2: "Minus",
  Digit3: "Digit0",
  Digit4: "Digit9",
  Digit5: "Digit8",
  Digit6: "Digit7",
  Digit7: "Digit6",
  Digit8: "Digit5",
  Digit9: "Digit4",
  Enter: "Enter",
  Equal: "Digit1",
  Escape: "Escape",
  F1: "F8",
  F10: "F5",
  F3: "F3",
  F5: "F10",
  F8: "F1",
  F9: "F9",
  ForwardMouseButton: "ForwardMouseButton",
  KeyA: "Quote",
  KeyB: "KeyN",
  KeyC: "Comma",
  KeyD: "KeyL",
  KeyE: "KeyO",
  KeyF: "KeyK",
  KeyG: "KeyJ",
  KeyH: "KeyH",
  KeyI: "KeyR",
  KeyJ: "KeyG",
  KeyK: "KeyF",
  KeyL: "KeyD",
  KeyM: "KeyV",
  KeyN: "KeyB",
  KeyO: "KeyE",
  KeyP: "KeyW",
  KeyQ: "BracketLeft",
  KeyR: "KeyI",
  KeyS: "Semicolon",
  KeyT: "KeyU",
  KeyU: "KeyT",
  KeyV: "KeyM",
  KeyW: "KeyP",
  KeyX: "Period",
  KeyY: "KeyY",
  KeyZ: "Slash",
  LeftMouseButton: "LeftMouseButton",
  Minus: "Digit2",
  Period: "KeyX",
  Quote: "KeyA",
  RightMouseButton: "RightMouseButton",
  Semicolon: "KeyS",
  Slash: "KeyZ",
  Tab: "BracketRight",
};
